const DELIVERY_STATUS = {
  notStarted: {
    name: 'NOT_STARTED',
    icon: '⏱',
  },
  inPacking: {
    name: 'IN_PACKING',
    icon: '💃',
  },
  readyForPickup: {
    name: 'READY_FOR_PICKUP',
    icon: '👜',
  },
  inProgress: {
    name: 'IN_PROGRESS',
    icon: '🚙',
  },
  finished: {
    name: 'FINISHED',
    icon: '✅',
  },
};

export default DELIVERY_STATUS;
